// IndexedDB を使った鑑賞履歴ストア
// レコード: { id, createdAt, title, artist, year, narration, imageBlob, audioBlob, museum }

const DB_NAME = 'museum-guide';
const DB_VERSION = 2;
const STORE = 'visits';
const TERMS_STORE = 'terms';

let dbPromise = null;

function openDB() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const store = db.createObjectStore(STORE, { keyPath: 'id' });
        store.createIndex('createdAt', 'createdAt');
      }
      if (!db.objectStoreNames.contains(TERMS_STORE)) {
        const ts = db.createObjectStore(TERMS_STORE, { keyPath: 'term' });
        ts.createIndex('lastSeen', 'lastSeen');
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

// ===== Terms (美術用語コレクション) =====
export async function saveTerm({ term, reading, meaning, visitId, visitTitle }) {
  if (!term || !meaning) return null;
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(TERMS_STORE, 'readwrite');
    const store = tx.objectStore(TERMS_STORE);
    const getReq = store.get(term);
    getReq.onsuccess = () => {
      const existing = getReq.result;
      const occurrences = existing?.occurrences || [];
      if (visitId && !occurrences.some((o) => o.visitId === visitId)) {
        occurrences.push({ visitId, visitTitle: visitTitle || '', date: Date.now() });
      }
      const record = {
        term,
        reading: reading || existing?.reading || '',
        meaning: meaning || existing?.meaning || '',
        occurrences: occurrences.slice(-20),
        firstSeen: existing?.firstSeen || Date.now(),
        lastSeen: Date.now(),
      };
      store.put(record);
    };
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function listTerms(limit = 200) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(TERMS_STORE, 'readonly');
    const idx = tx.objectStore(TERMS_STORE).index('lastSeen');
    const req = idx.openCursor(null, 'prev');
    const items = [];
    req.onsuccess = (event) => {
      const cursor = event.target.result;
      if (cursor && items.length < limit) {
        items.push(cursor.value);
        cursor.continue();
      } else {
        resolve(items);
      }
    };
    req.onerror = () => reject(req.error);
  });
}

export async function deleteTerm(term) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(TERMS_STORE, 'readwrite');
    tx.objectStore(TERMS_STORE).delete(term);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function saveVisit(record) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).put(record);
    tx.oncomplete = () => resolve(record);
    tx.onerror = () => reject(tx.error);
  });
}

export async function getVisit(id) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const req = tx.objectStore(STORE).get(id);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  });
}

export async function listVisits(limit = 50) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const idx = tx.objectStore(STORE).index('createdAt');
    const req = idx.openCursor(null, 'prev');
    const items = [];
    req.onsuccess = (event) => {
      const cursor = event.target.result;
      if (cursor && items.length < limit) {
        items.push(cursor.value);
        cursor.continue();
      } else {
        resolve(items);
      }
    };
    req.onerror = () => reject(req.error);
  });
}

export async function deleteVisit(id) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export function generateId() {
  return `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}
